
import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileErrorBoundary from './mobile/MobileErrorBoundary';
import { WebsiteSecurityProvider } from './security/WebsiteSecurityProvider';
import PerformanceMonitor from '@/components/seo/PerformanceMonitor';
import { usePageTracking } from '@/hooks/usePageTracking';
import SkipLinks from './SkipLinks';


interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  usePageTracking();
  return (
    <WebsiteSecurityProvider>
      <SkipLinks />
      <div className="min-h-screen flex flex-col">
        <MobileErrorBoundary>
          <Header />
        </MobileErrorBoundary>
        <main id="main-content" className="flex-1">
          <MobileErrorBoundary>
            {children}
          </MobileErrorBoundary>
        </main>
        <Footer />
        <PerformanceMonitor />
        
      </div>
    </WebsiteSecurityProvider>
  );
};

export default Layout;
